const RANK = [
  { id: 1, name: "红毯风波", cat: "事件查询", heat: 9324000, trend: "up", strong: true },
  { id: 2, name: "录音门完整音频", cat: "事件查询", heat: 6218000, trend: "up" },
  { id: 3, name: "某某人物专题", cat: "人物专题", heat: 4587000, trend: "down" },
  { id: 4, name: "解约细节疑云", cat: "事件查询", heat: 3120000, trend: "up" },
  { id: 5, name: "机场偶遇完整版", cat: "站内查找", heat: 2684000, trend: "new" },
  { id: 6, name: "直播翻车名场面", cat: "事件查询", heat: 2156000, trend: "flat" },
  { id: 7, name: "旧番考古合集", cat: "人物专题", heat: 1739000, trend: "up" },
  { id: 8, name: "新剧路透对比图", cat: "站内查找", heat: 1282000, trend: "down" },
];

const trendIcon = (t: string) => {
  if (t === "up") return <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center text-red-600"></i>;
  if (t === "down") return <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center text-stone-400"></i>;
  if (t === "new") return <span className="text-[10px] font-bold text-amber-600">NEW</span>;
  return <i className="ri-more-2-fill w-4 h-4 flex items-center justify-center text-stone-300"></i>;
};

const formatHeat = (n: number) => {
  if (n >= 10000) return `${(n / 10000).toFixed(1)} 万`;
  return `${n}`;
};

export default function TrendingRank() {
  return (
    <section id="trend" className="border-y border-[#e5ded2] bg-white/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-sm font-semibold text-red-700">
              <span className="h-px w-8 bg-red-700"></span>
              全网热搜 · 站内查找 Top
            </div>
            <h2 className="font-serif-sc mt-3 text-balance text-2xl font-black text-stone-900 md:text-3xl">
              此刻全网，最想搜的一件事
            </h2>
          </div>
          <div className="flex items-center gap-1 text-xs text-stone-400">
            <i className="ri-arrow-left-right-fill w-4 h-4 flex items-center justify-center text-red-700"></i>
            榜单 30 分钟更新一次
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {[0, 4].map((start) => (
            <div key={start} className="paper-card rounded-lg p-2 md:p-3">
              {RANK.slice(start, start + 4).map((r) => (
                <div
                  key={r.id}
                  className="flex items-center gap-4 rounded-md px-3 py-3 transition-colors hover:bg-red-700/5"
                >
                  <span
                    className={`font-serif-sc w-8 shrink-0 text-center text-2xl font-black ${
                      r.strong ? "text-red-700" : "text-stone-300"
                    }`}
                  >
                    {String(r.id).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <a
                      href="#hot"
                      className={`flex items-center gap-2 whitespace-nowrap text-sm font-semibold transition-colors hover:text-red-700 ${
                        r.strong ? "text-stone-900" : "text-stone-700"
                      }`}
                    >
                      {r.name}
                      {r.strong && (
                        <span className="rounded-sm bg-red-700 px-1.5 py-0.5 text-[10px] font-bold text-[#f7f3eb]">爆</span>
                      )}
                    </a>
                    <p className="mt-0.5 text-[11px] text-stone-400">{r.cat}</p>
                  </div>
                  <div className="flex shrink-0 items-center gap-2">
                    <span className="text-xs tabular-nums text-stone-500">{formatHeat(r.heat)}</span>
                    <span className="inline-flex w-5 items-center justify-center">{trendIcon(r.trend)}</span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <p className="mt-5 text-center text-xs text-stone-400">
          数据来源于网曝网关键词库 · 事件查询与人物专题热度综合加权
        </p>
      </div>
    </section>
  );
}